module.exports = __webpack_public_path__ + "img/carpenter.b1026d3c.png";